import React, { PureComponent } from 'react';
import { any, object } from 'prop-types';
import { Mutation } from 'react-apollo';
import { isFunction } from 'lodash';

class MutationManager extends PureComponent {
    static propTypes = {
        children: any,
        mutation: object,
        onError: any
    }

    render () {
        const { children, mutation, onError, ...props } = this.props;
        return (
            <Mutation mutation={mutation} {...props}>
                {(updateFn, { loading, error, data, client }, ...props) => {
                    if (error) return onError || `Error! ${error.message}`;
                    return isFunction(children) && children({ updateFn, loading, client, error, data });
                }}
            </Mutation>
        );
    }
}

export default MutationManager;
